<template>
  <div>
    <v-toolbar flat>
      <v-toolbar-title>Device details</v-toolbar-title>
    </v-toolbar>
    <v-simple-table>
      <template v-slot:default>
        <div v-show="subscriptionLoading" class="text-center pt-3">
          <v-progress-linear
            indeterminate
            color="primary"
          />
        </div>
        <tbody>
        <v-alert v-show="subscriptionError" text dense type="error">
          {{subscriptionError}}
        </v-alert>
        <tr>
          <td class="first-column">Alias:</td>
          <td><span class="mr-3">{{ subscriptionUnit.alias }}</span>
            <v-btn small rounded @click="aliasModal = true" color="secondary">
            <v-icon small>mdi-pencil</v-icon>
          </v-btn>
          </td>
        </tr>
        <tr>
          <td class="first-column">Type:</td>
          <td>{{ subscriptionUnit.transientType }}</td>
        </tr>
        <tr>
          <td class="first-column">Notes:</td>
          <td><span class="mr-3">{{ subscriptionUnit.notes }}</span>
            <v-btn small rounded @click="noteModal = true" color="secondary">
            <v-icon small>mdi-pencil</v-icon>
            </v-btn>
          </td>
        </tr>
        <tr>
          <td class="first-column">Serial Number:</td>
          <td>{{ subscriptionUnit.serialNumber }}</td>
        </tr>
        <tr>
          <td class="first-column">Subscription Number:</td>
          <td>{{ subscriptionData.subscriptionNumber }}</td>
        </tr>
        </tbody>
      </template>
    </v-simple-table>
    <v-dialog scrollable :value="aliasModal" persistent :max-width="$vuetify.breakpoint.smAndDown ? '80%' : '30%'">
      <SingleInputForm ref="aliasForm" :error="aliasError" @submit-form="onSubmitAlias" @close="onCloseAliasModal" label-text="Alias" :initialInputValue="subscriptionUnit.alias"/>
    </v-dialog>
    <v-dialog scrollable :value="noteModal" persistent :max-width="$vuetify.breakpoint.smAndDown ? '80%' : '30%'">
      <SingleInputForm ref="noteForm" :error="noteError" @submit-form="onSubmitNotes" @close="onCloseNoteModal" label-text="Note" :initialInputValue="subscriptionUnit.notes"/>
    </v-dialog>
  </div>
</template>

<script>
import SingleInputForm from '../SingleInputForm'
export default {
  name: 'SubscriptionDetails',
  components: {
    SingleInputForm
  },
  data: function () {
    return {
      aliasModal: false,
      aliasError: '',
      noteModal: false,
      noteError: ''
    }
  },
  methods: {
    onSubmitAlias: function (alias) {
      this.$store.dispatch('subscription/saveUnitAlias', alias)
        .then(res => {
          this.$store.commit('setSuccessMessage', 'Alias has been changed')
          this.$refs.aliasForm.resetData()
          this.onCloseAliasModal()
        })
        .catch(err => {
          this.aliasError = err
        })
    },

    onCloseAliasModal: function () {
      this.aliasModal = false
      this.aliasError = ''
    },

    onSubmitNotes: function (notes) {
      this.$store.dispatch('subscription/saveUnitNotes', notes)
        .then(res => {
          this.$store.commit('setSuccessMessage', 'Notes has been changed')
          this.$refs.noteForm.resetData()
          this.onCloseNoteModal()
        })
        .catch(err => {
          this.noteError = err
        })
    },

    onCloseNoteModal: function () {
      this.noteModal = false
      this.noteError = ''
    }
  },

  computed: {
    subscriptionData: function () {
      return this.$store.state.subscription.currentSubscription.data
    },
    subscriptionError: function () {
      return this.$store.state.subscription.currentSubscription.error === null ? '' : this.$store.state.subscription.currentSubscription.error
    },
    subscriptionLoading: function () {
      return this.$store.state.subscription.currentSubscription.data.id === null && this.$store.state.subscription.currentSubscription.error === null
    },
    subscriptionUnit: function () {
      return this.$store.state.subscription.currentSubscriptionUnit
    }
  }

}
</script>

<style scoped>
  .first-column{
    width: 170px;
  }
</style>
